import React from "react";
import styles from "./index.module.scss";

interface EventHeaderProps {
    event: any;
    language: string;
}

const EventHeader = ({ event, language } : EventHeaderProps) => {
    const isNotEnglish = language !== "English";

    const {eventTitle, description, thumbnail} = event;
    return (
        <div className={styles.eventHeader}>
            <div className={styles.eventThumbnail}>
                {thumbnail && <img src={thumbnail} alt="Event Thumbnail" />}
            </div>
            <div className={`${styles.eventTitle} ${isNotEnglish ? "alignRightBold" : ""}`}>{eventTitle}</div>
            {description && <div className={styles.eventDescription}>{description}</div>}
        </div>
    );
};

export default EventHeader;